"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.targets = exports.ruleOperators = exports.conditionOperators = void 0;
const conditionOperators = exports.conditionOperators = {
  EQUALS: 'equals',
  HAS_ANY_VALUE: 'hasAnyValue',
  HAS_NO_VALUE: 'hasNoValue'
};
const ruleOperators = exports.ruleOperators = {
  ALL: 'all',
  ANY: 'any'
};
const targets = exports.targets = {
  BLOCK: 'block',
  CAMPAIGN: 'campaign'
};